import Enum from "../../../enums/Enum";

const EnumBodySilhouetteSignTypes = new Enum({
    ARROW: "Arrow",
    CIRCLE: "Circle",
    CROSS: "Cross",
    LABEL: "Label"
});

export default EnumBodySilhouetteSignTypes;